import { useQuery } from 'react-query';
import { ReactQueryKeys } from '../../../Constants/ClientRoutingConstants';
import assetsApiService from '../Utilities/AssetsApiService';
import templatesApiService from '../../Templates/Utilities/TemplatesApiService';
import AssetTemplateReadDto from '../../../Models/Assets/AssetTemplateReadDto';
import AssetImageReadDto from '../../../Models/Assets/AssetImageReadDto';
import { RequirementReadDto } from '../../../Models/Requirement/RequirementReadDto';
import UnmappedEndpointsReadDto from '../../../Models/Assets/UnmmapedEndpointsReadDto';
import GatewaysReadDto from '../../../Models/Assets/GatewaysReadDto';

export const useAssetConfigurationQueries = (
  isEdit: boolean,
  selectedTemplate: any,
  templateData: any
) => {
  const templateConfigQuery = useQuery<AssetTemplateReadDto>(
    [ReactQueryKeys.SelectedTemplateQuery, selectedTemplate?.id],
    () => templatesApiService.getTemplateAsset(selectedTemplate!.id),
    {
      enabled: !isEdit && !!selectedTemplate?.id,
    }
  );

  const assetImageQuery = useQuery<AssetImageReadDto>(
    [ReactQueryKeys.AllAssetImagesQuery, templateData?.imageId],
    () => assetsApiService.getAssetImages(templateData!.imageId),
    {
      enabled: !!templateData?.imageId,
    }
  );

  const unmappedEndpointDevicesQuery = useQuery<Array<UnmappedEndpointsReadDto>>(
    ReactQueryKeys.UnmappedEndpointDevicesQuery,
    () => assetsApiService.getUnmappedEndpointDevices()
  );

  const requirementsQuery = useQuery<Array<RequirementReadDto>>(
    ReactQueryKeys.AllRequirementQuery,
    () => assetsApiService.getAllRequirements()
  );

  const gatewaysQuery = useQuery<Array<GatewaysReadDto>>(
    ReactQueryKeys.AllGatewaysQuery,
    () => assetsApiService.getAllGateways()
  );

  return {
    templateConfigQuery,
    assetImageQuery,
    unmappedEndpointDevicesQuery,
    requirementsQuery,
    gatewaysQuery,
  };
};

